import { FaFileDownload } from 'react-icons/fa';

export const columnsDataCreditNotes = [
  {
    Header: "Tipo",
    accessor: "invoiceType",
  },
  {
    Header: "Serie",
    accessor: "series",
  },
  {
    Header: "Número",
    accessor: "number",
  },
  {
    Header: "Fecha emisión",
    accessor: "issueDate",
    Cell: ({ value }) => {
      if (!value) return '-';
      return new Date(value).toLocaleDateString('es-UY', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
  {
    Header: "Cliente",
    accessor: "customer.displayName",
    Cell: ({ row }) => {
      const customer = row.original.customer;
      if (!customer) return '-';
      return customer.displayName || `${customer.documentNumber} - ${customer.name}`;
    }
  },
  {
    Header: "Total",
    accessor: "invoiceTotals.total",
    Cell: ({ value }) => {
      if (!value) return '-';
      return `$${parseFloat(value).toFixed(2)}`;
    }
  },
  {
    Header: "Estado",
    accessor: "status",
    Cell: ({ value }) => {
      return value || 'Procesada';
    }
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Descargar',
        icon: <FaFileDownload />,
        colorScheme: 'blue',
        type: 'print'
      }
    ]
  }
];
